/**
 * Fragrance Driver - Bucket definitions (A1 - A8)
 *
 * Each bucket has:
 *  - id          : the bucket code (A1..A8)
 *  - label       : the bucket question shown in UI / table
 *  - targetVariable : mapped Target Variable:
 *                       A1-A4 -> Overall Opinion Fragrance
 *                       A5    -> Fragrance Moments
 *                       A6-A8 -> Overall Opinion Product
 *  - kpis        : currently kept empty — the actual KPI questions are fetched
 *                   from the backend via GET /driver-analysis-output/fragrance-driver-kpis/
 *                   and passed as bucketKPIs to FragranceDriverTable.
 */

export const BUCKET_DATA = [
    {
        id: "A1",
        label: "A1 : Which fragrance attributes drive OOF?",
        target_kpi: "R_OO_Frag_ShampooAndConditioner",
        target_kpi_label: "Overall Opinion Fragrance",
        kpis: [],
    },
    {
        id: "A2",
        label: "A2 : Which fragrance and product attributes drive OOF?",
        target_kpi: "R_OO_Frag_ShampooAndConditioner",
        target_kpi_label: "Overall Opinion Fragrance",
        kpis: [],
    },
    {
        id: "A3",
        label: "A3 : Which product attributes drive OOF?",
        target_kpi: "R_OO_Frag_ShampooAndConditioner",
        target_kpi_label: "Overall Opinion Fragrance",
        kpis: [],
    },
    {
        id: "A4",
        label: "A4 : Which fragrance moments drive OOF?",
        target_kpi: "R_OO_Frag_ShampooAndConditioner",
        target_kpi_label: "Overall Opinion Fragrance",
        kpis: [],
    },
    {
        id: "A5",
        label: "A5 : Which fragrance attributes drive the fragrance experience across the different stages of washing?",
        target_kpi: "FRAGRANCE_MOMENTS_COMPOSITE",
        target_kpi_label:  "Fragrance Moments",
        kpis: [],
    },
    {
        id: "A6",
        label: "A6 : Which fragrance attributes drive OOP?",
        target_kpi: "R_OO_OverallOpinionOfProduct",
        target_kpi_label: "Overall Opinion Product",
        kpis: [],
    },
    {
        id: "A7",
        label: "A7 : Which fragrance and product attributes drive OOP?",
        target_kpi: "R_OO_OverallOpinionOfProduct",
        target_kpi_label: "Overall Opinion Product",
        kpis: [],
    },
    {
        id: "A8",
        label: "A8 : Which product attributes drive OOP?",
        target_kpi: "R_OO_OverallOpinionOfProduct",
        target_kpi_label: "Overall Opinion Product",
        kpis: [],
    },
];

/** Default bucket shown when nothing is selected yet (A1 - the only one with KPIs so far) */
export const DEFAULT_BUCKET = BUCKET_DATA[0];

/** react-select style options for the Bucket dropdown (shows only the code, e.g. A1, A2 ...) */
export const BUCKET_OPTIONS = BUCKET_DATA.map((bucket) => ({
    value: bucket.id,
    label: bucket.id,
}));
